export const CERTIFICATE_PANEL_HEADER = 'Certificate of Completion'
